import type { CampaignInclusionPeriodI } from "~/modules/campaign/components/CampaignOperationMgrFunnelStep3InclusionPeriods.vue";
import type { CampaignInclusionPeriod } from "~/modules/campaign/models/CampaignInclusionPeriod";

export function campaignInclusionPeriodsGetMapper(
  campaignInclusionPeriods: CampaignInclusionPeriod[],
): CampaignInclusionPeriodI[] {
  // Mapping abbreviations to full days
  const dayMapping: Record<string, string> = {
    Mo: "MONDAY",
    Tu: "TUESDAY",
    We: "WEDNESDAY",
    Th: "THURSDAY",
    Fr: "FRIDAY",
    Sa: "SATURDAY",
    Su: "SUNDAY",
  };

  const result: CampaignInclusionPeriodI[] = [];

  campaignInclusionPeriods.forEach((period) => {
    const daysString = period.days;
    const dayAbbreviations: string[] = [];

    for (let i = 0; i < daysString.length; i += 2) {
      const dayAbbr = daysString.substring(i, i + 2);
      if (dayAbbr.length === 2) {
        dayAbbreviations.push(dayAbbr);
      }
    }

    dayAbbreviations.forEach((dayAbbr) => {
      const fullDayName = dayMapping[dayAbbr];
      if (fullDayName) {
        result.push({
          day: fullDayName,
          start: period.startTime,
          end: period.endTime,
        });
      }
    });
  });

  return result;
}
